import { observer } from 'mobx-react-lite';
import { useResolve } from '@/infrastructure/useResolve';
import { TOKEN_II18n } from '@/services/i18n/I18n';
import { TOKEN_PlayerStore } from './PlayerStore';
import { UploadView } from './UploadView';
import { PlayerView } from './PlayerView';
import { ChapterListView } from './ChapterListView';
import { SearchView } from './SearchView';
import { ToastView } from './ToastView';

export const AppView = observer(function AppView() {
  const player = useResolve(TOKEN_PlayerStore);
  const i18n = useResolve(TOKEN_II18n);

  return (
    <div className="mx-auto flex h-screen max-w-2xl flex-col px-4">
      <main className="flex min-h-0 flex-1 flex-col py-3">
        {player.isHydrating ? (
          <p className="m-auto text-sm text-muted">{i18n.t('app.loading')}</p>
        ) : player.hasBook ? (
          <PlayerView />
        ) : (
          <UploadView />
        )}
      </main>

      <ChapterListView />
      <SearchView />
      <ToastView />
    </div>
  );
});
